// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"97883c1d","141":"5a9405d7","240":"fc9987b8","369":"9139a67f","383":"2a1b3fed","453":"1b31a63b","457":"7258cf98","463":"9f0e6728","544":"61cb7d1c","645":"bd8b3903","680":"f2863b27","690":"d985ef28","702":"657eeb13","834":"2b51bed5","900":"c51a369c"}[chunkId] + ".chunk.js";
};